export default {"src":"/_next/static/media/illustrator.7eb9c9f7.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};